module.exports = __webpack_public_path__ + "static/media/stl-today.870f55c2.jpg";